import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import SectionTableHeader from './SectionTableHeader';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search } from 'services/skill-matric-services/smSectionService';
import PageHeader from 'components/common/PageHeader';
import SectionTable from './SectionTable';
import SectionModal from './SectionModal';

const SectionDashboard = () => {
  const defaultRQ = { ...new BaseTableRQ(1, 5) };
  const [sections, setSections] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [isFilter, setIsFilter] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState({});

  useEffect(() => {
    setIsFilter(false);
  }, []);

  const gotoPage = index => {
    index += 1;
    if (index <= 0) return;
    paging.pageNum = index;
    loadSections(paging);
  };

  const toggelFilter = () => {
    setIsFilter(!isFilter);
  };
  const addNew = () => {
    setIsModal(true);
    setDataModal(null);
  };

  const nextPage = () => {
    const page = paging.pageNum + 1;
    if (page > Math.ceil(total / paging.pageSize)) return;
    paging.pageNum = page;
    loadSections(paging);
  };

  const previousPage = () => {
    const page = paging.pageNum - 1;
    if (page <= 0) return;
    paging.pageNum = page;
    loadSections(paging);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    setDataModal(null);
  };
  const handleSubmitModal = () => {
    handleCloseModal();
    loadSections(defaultRQ);
  };

  useEffect(() => {
    loadSections(defaultRQ);
  }, []);

  const loadSections = pagingRq => {
    search(pagingRq)
      .then(res => {
        if (res) {
          setSections(res.items);
          setTotal(res.total);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setPaging(pagingRq);
  };

  const handleSeach = keyword => {
    loadSections({ ...defaultRQ, keyword });
  };

  return (
    <>
      <PageHeader
        title="Section"
        description={`Manage and view all available Sections from this page.`}
        className="mb-3"
      ></PageHeader>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <Row style={{ padding: '10px' }}>
              <SectionTableHeader
                toggelFilter={() => toggelFilter()}
                toggelModal={() => addNew()}
                handleSearch={handleSeach}
                style={{ padding: '10px' }}
              />
              <Col lg={isFilter ? 9 : 12}>
                <SectionTable
                  data={sections}
                  paging={paging}
                  total={total}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  gotoPage={gotoPage}
                  handleClickRow={(e, row) => {
                    if (row) {
                      setDataModal(row.original);
                      setIsModal(true);
                    }
                  }}
                />
              </Col>
              {/* 
              {isFilter && (
                <Col lg={3}>
                  <ActionPlanFilter
                    handleChange={handleChange}
                    formData={filter}
                    handleSubmit={handleSubmit}
                  />
                </Col>
              )} */}
            </Row>
          </Card>
        </Col>
      </Row>
      <SectionModal
        isShow={isModal}
        handleClose={handleCloseModal}
        data={dataModal}
        handleSubmit={handleSubmitModal}
      />
    </>
  );
};

SectionDashboard.propTypes = {};

export default SectionDashboard;
